export default __webpack_public_path__ + "static/media/modal-online.0609c32d.gif";